import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "menu-item-text" }
const _hoisted_2 = { class: "menu-item-text" }

import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContextualMenuSelection',
  props: {
  show: Boolean,
  position: {
    type: Object as PropType<{ x: number; y: number }>,
    required: true
  },
  text: String
},
  emits: ['copy', 'insert'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const handleCopy = () => {
  emit('copy', props.text);
};

const handleInsert = () => {
  emit('insert', props.text);
};

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "context-menu",
        style: _normalizeStyle({ top: __props.position.y + 'px', left: __props.position.x + 'px' })
      }, [
        _createElementVNode("button", {
          class: "menu-item",
          onClick: handleCopy
        }, [
          _createVNode(AppIcon, {
            class: "icon",
            name: "copy-text",
            size: "body-xl",
            "class-name": "color-lighter"
          }),
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('legal_assistant.actions.copy')), 1)
        ]),
        _createElementVNode("button", {
          class: "menu-item",
          onClick: handleInsert
        }, [
          _createVNode(AppIcon, {
            class: "icon",
            name: "insert-text",
            size: "body-xl",
            "class-name": "color-lighter"
          }),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('legal_assistant.actions.insert')), 1)
        ])
      ], 4))
    : _createCommentVNode("", true)
}
}

})